import { useMemo } from 'react';

import sizes from '@polyai/ui/styles/config/sizes';

import { useAppSelector } from './reduxHooks';
import useBannerOffset from './useBannerOffset';

const useHeaderOffset = () => {
  const isActionHeaderOpen = useAppSelector(
    state => state.layout.isActionHeaderOpen,
  );

  const isPreviewHeaderOpen = !!useAppSelector(
    state => state.project.preview.deploymentId,
  );

  const bannerOffset = useBannerOffset();

  const isHeaderExtended = isActionHeaderOpen || isPreviewHeaderOpen;

  return useMemo(() => {
    let offset = sizes.headerHeight;

    if (isHeaderExtended) {
      offset += sizes.actionHeaderHeight;
    }

    offset += bannerOffset;

    return offset;
  }, [isHeaderExtended, bannerOffset]);
};

export default useHeaderOffset;
